import React, { useState, useEffect } from 'react';
import projectsData from '../Data/projects.json';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faGooglePlay, faItchIo, faYoutube } from '@fortawesome/free-brands-svg-icons';
import moment from 'moment';

const Project = () => {
    const [projects, setProjects] = useState([]);
    const [gameplayImages, setGameplayImages] = useState({});

    useEffect(() => {
        setProjects(projectsData);

        const imagesByProject = {};
        projectsData.forEach((project) => {
            const count = project.gameplayImagesCounts || 0;
            const images = [];

            // Generate image paths dynamically and use require
            for (let i = 1; i <= count; i++) {
                try {
                    const imagePath = require(`../Data/GameplayImages/${project.projectName}/${i}.png`);
                    images.push(imagePath);
                } catch (error) {
                    console.error(`Failed to load image for ${project.projectName}/${i}.png`, error);
                }
            }

            imagesByProject[project.projectName] = images;
        });

        setGameplayImages(imagesByProject);
        console.log('Generated images:', imagesByProject);
    }, []);

    useEffect(() => {
        console.log('Updated gameplayImages:', gameplayImages);
    }, [gameplayImages]);

    return (
        <div>
            {projects.map((project, index) => (
                <div key={index} className="pad">
                    <div className="fx fx-align-center">
                        <h2 className="c-heading ft-w-bold">{project.projectName}</h2>
                    </div>
                    <div className="fx-col fx-far fx-gap">
                        <div>
                            <div>
                                {project.projectDescription.map((paragraph, idx) => (
                                    <p key={idx}>{paragraph}</p>
                                ))}
                            </div>
                            <div className="ft-italic">
                                <strong className="c-light">Key Features:</strong>
                            </div>
                            <div>
                                <ul>
                                    {project.keyFeatures.map((feature, index) => (
                                        <li key={index} dangerouslySetInnerHTML={{ __html: feature }} />
                                    ))}
                                </ul>
                            </div>
                            <div className="ft-italic">
                                <strong className="c-light">Technologies & Concepts:</strong>
                            </div>
                            <div>
                                <ul>
                                    {project.technologyUsed.map((feature, index) => (
                                        <li key={index} dangerouslySetInnerHTML={{ __html: feature }} />
                                    ))}
                                </ul>
                            </div>

                            <div className="fx-col fx-gap-s mg-y-10 c-light">
                                <div className="ft-italic ft-s-normal">
                                    {project.workingStatus + ' ' + moment(project.dateOfCreation).fromNow()}
                                </div>
                                <div className="fx fx-gap">
                                    {project.githubURL && (
                                        <Link
                                            to={project.githubURL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="c-light link txt-no-decorate"
                                        >
                                            Source <FontAwesomeIcon icon={faGithub} />
                                        </Link>
                                    )}
                                    {project.itchioURL && (
                                        <Link
                                            to={project.itchioURL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="c-play link txt-no-decorate"
                                        >
                                            Play <FontAwesomeIcon icon={faItchIo} />
                                        </Link>
                                    )}
                                    {project.playStoreURL && (
                                        <Link
                                            to={project.playStoreURL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="c-light link txt-no-decorate"
                                        >
                                            Download <FontAwesomeIcon icon={faGooglePlay} />
                                        </Link>
                                    )}
                                    {project.youtubeURL && (
                                        <div /* className="youTubeLink" */>
                                            <Link
                                                to={project.youtubeURL}
                                                className="c-watch link txt-no-decorate"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Watch <FontAwesomeIcon icon={faYoutube} />
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="screenshot-section">
                                <div className="screenshot-heading">Gameplay Screenshots </div>
                                <div className="img-frame-gameplay">
                                    {project.gameplayImagesCounts > 0 && gameplayImages[project.projectName]?.length > 0 ? (
                                        gameplayImages[project.projectName].map((image, imgIdx) => (
                                            <div key={imgIdx}>
                                                <img
                                                    src={image}
                                                    alt={`Project ${project.projectName} Image ${imgIdx + 1}`}
                                                    className={`${index == 0 ? 'img-project-land' : 'img-project'}`}
                                                />
                                            </div>
                                        ))
                                    ) : (
                                        <span>No Images</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hr"></div>
                </div>
            ))}
        </div>
    );
};

export default Project;